import { render, staticRenderFns } from "./AppCursor.vue?vue&type=template&id=1a385ee0"
import script from "./AppCursor.vue?vue&type=script&lang=js"
export * from "./AppCursor.vue?vue&type=script&lang=js"
import style0 from "./AppCursor.vue?vue&type=style&index=0&id=1a385ee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports